import './case-gallery.scss';
import 'slick-carousel';
import 'magnific-popup';

export default () => {
	// Slick slider
	$( '.js-case-gallery-for' ).slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		rows: 0,
		asNavFor: '.js-case-gallery-nav',
	} );

	$( '.js-case-gallery-nav' ).slick( {
		slidesToShow: 5,
		slidesToScroll: 1,
		asNavFor: '.js-case-gallery-for',
		dots: false,
		rows: 0,
		arrows: true,
		focusOnSelect: true,
		appendArrows: '.case-gallery__nav-arrows',
		nextArrow: '<button class="slick-next"><i class="icon-arrow-right"></i></button>',
		prevArrow: '<button class="slick-prev"><i class="icon-arrow-right"></i></button>',
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
				},
			},
		],
	} );

	// Magnific popup
	$( '.js-popup-video' ).magnificPopup( {
		type: 'iframe',
		mainClass: 'mfp-img-mobile',
	} );

	$( '.js-popup-image' ).magnificPopup( {
		type: 'image',
		mainClass: 'mfp-img-mobile',
	} );
};
